module.exports = __webpack_public_path__ + "images/brand-performance-9ea96779.svg";